import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { DELIVERY_MODEL_TYPE, type OnlineDeliveryman } from '../../types';

import { image } from '@/Themes/Images';
import { MOTOBOY_STATUS } from '@/Constants';

function MarkerDeliveryman({
  deliveryman,
  index,
}: {
  deliveryman: OnlineDeliveryman;
  index: number;
}) {
  if (!deliveryman.localization) {
    return null;
  }

  const pointerIconDisponivel = new L.Icon({
    iconUrl: image.marker_disponivel,
    iconAnchor: [20, 45],
    popupAnchor: [10, -44],
    iconSize: [40, 45],
  });

  const pointerIconIndoEstabelecimento = new L.Icon({
    iconUrl: image.marker_indo_estabelecimento,
    iconAnchor: [20, 45],
    popupAnchor: [10, -44],
    iconSize: [40, 45],
  });

  const pointerIconEntregando = new L.Icon({
    iconUrl: image.marker_entregando,
    iconAnchor: [20, 45],
    popupAnchor: [10, -44],
    iconSize: [40, 45],
  });

  const iconDeliverymanImages = {
    [MOTOBOY_STATUS.DISPONIVEL]: pointerIconDisponivel,
    [MOTOBOY_STATUS.ENTREGA_ASSOCIADA]: pointerIconIndoEstabelecimento,
    [MOTOBOY_STATUS.EM_CORRIDA]: pointerIconEntregando,
  };

  const DELIVERYMAN_TYPE_LABEL: Record<DELIVERY_MODEL_TYPE, string> = {
    [DELIVERY_MODEL_TYPE.CLOUD]: 'Entregador nuvem',
    [DELIVERY_MODEL_TYPE.LINKED]: 'Entregador próprio',
    [DELIVERY_MODEL_TYPE.CLOUD_AND_LINKED]: 'Entregador nuvem e próprio',
  };

  return (
    <Marker
      icon={iconDeliverymanImages[deliveryman.status]}
      key={index}
      position={[
        deliveryman.localization.coordinates[1],
        deliveryman.localization.coordinates[0],
      ]}
    >
      <Popup>
        <div>
          <div>
            <strong>Nome: </strong>
            <span>{deliveryman.deliverymanName}</span>
          </div>
          <div>
            <strong>Status: </strong>
            <span>{deliveryman.status.replace(/_/, ' ')}</span>
          </div>
          {deliveryman.deliverymanType && (
            <div>
              <strong>Tipo: </strong>
              <span>{DELIVERYMAN_TYPE_LABEL[deliveryman.deliverymanType]}</span>
            </div>
          )}
        </div>
      </Popup>
    </Marker>
  );
}

export { MarkerDeliveryman };
